import { HTTPv2, Service } from '@/services/config'
import { removePropertyEmpty } from '@/utils/index'

class PrecificationServiceV2 extends Service {
  path = 'precificacao'

  constructor() {
    super(HTTPv2)
  }

  async get(
    perPage: number,
    page: number,
    sortField: string = '',
    sortAscending: boolean = true,
    params: any
  ) {
    const payloadSubmitted = {
      ...params,
      PageSize: perPage,
      Page: page,
      SortField: sortField,
      SortAscending: sortAscending
    }

    const httpResponse = await this.httpClient.get(this.path, {
      params: removePropertyEmpty(payloadSubmitted)
    })

    return httpResponse
  }

  async getVistorias(params?: any) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/obtervistorias`,
      {
        params: removePropertyEmpty(params)
      }
    )
    return httpResponse
  }

  async getVistoriaVeiculo(precificacaoId: string) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/obtervistoriaveiculo/${precificacaoId}`
    )
    return httpResponse
  }

  async putMargins(params?: any) {
    const httpResponse = await this.httpClient.put(
      `${this.path}/editarmargenslote`,
      params
    )

    return httpResponse
  }

  async getPrecificationHistoryV2(precificationId: string) {
    const params = {
      precificacaoId: precificationId
    }
    const httpResponse = await this.httpClient.get(
      `${this.path}/obterValorHistorico`,
      { params }
    )
    return httpResponse
  }

  async finish(payload: any) {
    const httpResponse = await this.httpClient.post(
      `${this.path}/finalizar`,
      payload
    )
    return httpResponse
  }

  async update(payload: any) {
    const httpResponse = await this.httpClient.put(`${this.path}`, payload)
    return httpResponse
  }

  async download(params: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/excel`, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }
}

export const precificationServiceV2 = new PrecificationServiceV2()
